import React from 'react';
import { useLocation } from 'react-router-dom';

export const LoginPage = () => {
  const location = useLocation();
  const errorMessage = location.state?.error;
  
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left Panel - Login Form */}
      <div className="w-full lg:w-[40%] bg-[#121212] flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          {/* Logo/Brand */}
          <div className="mb-12">
            <h1 className="text-3xl font-semibold text-white">
              Luxsun Nordic
            </h1>
            <p className="text-sm mt-2" style={{ color: 'rgba(255,255,255,0.6)' }}>
              Operations Dashboard
            </p>
          </div>

          {/* Error Message */}
          {errorMessage && (
            <div className="mb-6 p-4 bg-[#B3261E]/10 border border-[#B3261E]/30 text-[#B3261E] text-sm rounded-lg">
              {errorMessage}
            </div>
          )}

          {/* Login Section */}
          <div className="space-y-6">
            <div>
              <h2 className="text-xl font-semibold text-white mb-2">Sign in</h2>
              <p className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>
                Access restricted to @gardinbussen.org accounts
              </p>
            </div>

            <button
              onClick={handleGoogleLogin}
              className="w-full flex items-center justify-center gap-3 bg-[#1E6F7A] text-white font-medium text-sm py-4 px-6 rounded-lg hover:bg-[#1E6F7A]/80 transition-colors duration-200"
              data-testid="google-login-btn"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="currentColor"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="currentColor"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="currentColor"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              Continue with Google
            </button>

            <p className="text-center text-xs" style={{ color: 'rgba(255,255,255,0.6)' }}>
              Only @gardinbussen.org emails accepted
            </p>
          </div>

          {/* Footer */}
          <div className="mt-16 pt-8 border-t border-white/10">
            <p className="text-xs" style={{ color: 'rgba(255,255,255,0.6)' }}>
              Luxsun Nordic Operations
            </p>
          </div>
        </div>
      </div>

      {/* Right Panel - Visual */}
      <div 
        className="hidden lg:block lg:w-[60%] relative bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1748525874503-7ed3db0ccccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGRhcmslMjBnZW9tZXRyaWMlMjBuZXR3b3JrJTIwc3RydWN0dXJlfGVufDB8fHx8MTc3MDYyODI4N3ww&ixlib=rb-4.1.0&q=85')`
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/70 backdrop-blur-sm"></div>
        
        {/* Decorative Content */}
        <div className="relative z-10 h-full flex items-center justify-center p-12">
          <div className="text-center">
            <div className="w-24 h-24 border border-white/20 rounded-lg mx-auto mb-8 flex items-center justify-center">
              <div className="w-16 h-16 border border-white/30 rounded-lg flex items-center justify-center">
                <div className="w-8 h-8 bg-[#1E6F7A]/30 rounded"></div>
              </div>
            </div>
            <p className="text-sm uppercase tracking-widest" style={{ color: 'rgba(255,255,255,0.6)' }}>
              Real-time Operations
            </p>
            <p className="text-2xl font-semibold text-white mt-2">
              Data Driven Decisions
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
